import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center p-6">
      <div className="glass rounded-2xl p-8 max-w-md w-full text-center border border-white/10" data-testid="stripe-payment-cancel-page">
        <XCircle className="w-14 h-14 text-amber-300 mx-auto mb-4" />
        <h1 className="text-2xl font-black mb-3">Payment canceled</h1>
        <p className="text-white/65 mb-6">No charge was made. You can return to Premium whenever you&apos;re ready.</p>
        <Link to="/subscription" data-testid="stripe-cancel-return-link"><Button className="bg-[#00f2ea] text-black hover:bg-[#00d4d4]">Back to Premium</Button></Link>
      </div>
    </div>
  );
}